import { DetailBase } from './detail-base.component';
import { DetailOptions } from '.';
export class DetailModel<TModel> extends DetailBase<TModel> {
  constructor(options: DetailOptions<TModel>) {
    super(options);
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-structures/detail/detail.model.ts